<template>
  <div>123</div>
<!--<abc />-->
</template>

<script>
// import abc from '@/views/finished-goods-order/base-data/supplier-process-ranking'
export default {
  name: 'Index'
  // components: { abc }
}
</script>

<style scoped>

</style>
